import { combineReducers } from "redux";
import userReducer from "../slices/user/index";
import commonReducer from "../slices/common";
import signUpFieldsReducer from "../slices/Registration/SignUpSlices";
import userCommonReducer from "./Registration/CommonSlices";
import userGoogleSignInReducer from "./Registration/GoogleSignInSlice";

export default combineReducers({
  userData: userReducer,
  commonData: commonReducer,
  userSignUpFields: signUpFieldsReducer,
  usersCommonData: userCommonReducer,
  usersGoogleSiginIn: userGoogleSignInReducer
});
